import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        let error = '';
        if (err.status === 401) {
          this.authenticationService.logout();
          location.reload();
        } else if (err.status >= 500 && err.status < 600) {
          error = 'Something went wrong!';
        } else {
          error = err || err.statusText;
        }
        return throwError(() => error);
      })
    );
  }
}
